import React from 'react';

const FlagIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <title>CCC82D4C-2A73-4E4D-BDE9-D9DCED2EF971</title>
    <g id="Episode-Comment" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Comments_Reported-_CommentTEST" transform="translate(-18.000000, -396.000000)" fill="#999999">
        <g id="Navigations">
          <g id="menu_close" transform="translate(0.000000, 64.000000)">
            <g id="Group">
              <g transform="translate(2.000000, 13.000000)">
                <g id="Navigations/Moderation" transform="translate(0.000000, 307.000000)">
                  <g id="Icons/SVG/ReportFlag">
                    <g transform="translate(16.000000, 12.000000)">
                      <g id="ReportFlag" transform="translate(5.000000, 3.000000)">
                        <path
                          d="M1,0 C1.55228475,0 2,0.444946289 2,0.993397683 L2,17.0066023 C2,17.5160523 1.61727982,17.935933 1.11733256,17.9933167 L1,18 C0.44771525,18 0,17.5550537 0,17.0066023 L0,0.993397683 C0,0.483947749 0.382720178,0.0640670371 0.882667443,0.00668331271 L1,0 Z M6.68175,0.861 C9.6075,0.861 9.6645,3.03225 12.1845,3.03225 C13.78425,3.03225 15,1.95975 15,1.95975 L14.999,1.96 L15,10.98075 C15,10.98075 13.994766,11.9094468 12.5191886,11.9938738 L12.30525,12 C9.843,12 9.45525,9.9345 6.69225,9.9345 C5.23425,9.9345 3.888,10.581 3,11.19525 L3,11.19525 L3,2.1315 C3.6255,1.596 5.10075,0.861 6.68175,0.861 Z"
                          id="Combined-Shape"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FlagIcon;
